<div class="grid">
    <div class="col-12">
        <div class="flex gap-4 mt-4">
            <p-fileupload #fileUploader name="file" mode="basic" (onSelect)="onFileSelect($event)" [auto]="false"
                          chooseLabel="Datei auswählen" [customUpload]="true">
            </p-fileupload>

            @if (busy) {
                <p-skeleton width="3rem" height="3rem"></p-skeleton>
            }
            <p-button [disabled]="!selectedFile || busy" label="Verarbeiten"
                      (click)="processDocument(fileUploader)"></p-button>
        </div>
    </div>

    <div class="col-12">
        @if (emSchemaRuntimeDataDto) {
            <em-schema-runtime-data
                    [schemaData]="emSchemaRuntimeDataDto"
            ></em-schema-runtime-data>
        }
    </div>
</div>